import React from "react";
import { connect } from "react-redux";
import {
  Layout,
  Row,
  Col,
  Button,
  message,
  Icon
} from "antd";
import { ContactUsURL } from "./../../modules/emails/endpoints"
import HeaderNavigationContainer from "../../components/HeaderNavigation/container";
import FooterContainer from "../../components/Footer/container";

const { Header, Content } = Layout;

function Contact(props) {

  return (
    <Layout
      className="layout homebg"
      style={{
        background: "#000",
        backgroundSize: "cover"
      }}
    >
      <HeaderNavigationContainer />
      <Header className="">
        <div
          style={{
            color: "#fff",
            position: "relative",
            width: "100%",
            bottom: 0,
            marginTop: "10%"
          }}
        >
          <h1 className="header_headline" style={{ color: "#1abc9c" }}>
            {props.language === "en" ? "CONTACT" : "KONTAKT"}
          </h1>

          <div
            style={{
              position: "absolute",
              zIndex: 1,
              display: "flex",
              justifyContent: "center",
              width: "100%"
            }}
          >
            <button
              onClick={() => window.scrollBy(0, 500)}
              className="arrow_button"
            >
              <i className="arrow arrow_down" />
            </button>
          </div>
        </div>
      </Header>
      <Content>
        <Row
          style={{
            background: "#FFF",
            height: "auto",
            padding: "50px 0 150px"
          }}
        >
          <Col
            sm={24}
            md={{ span: 10 }}
            style={{ position: "relative", height: "100%" }}
          >
            <div className="block_align align_left">
              <div>
                <div className="block_body_left" />
                <iframe
                  title='Contact'
                  className="block_body_left"
                  label='contact'
                  style={{ visibility: "hidden" }}
                  width="0"
                  height="0"
                  border="0"
                  name="dummyfram"
                  id="dummyfram"
                />
                <form
                  class="form-horizontal"
                  method="POST"
                  action={ContactUsURL}
                  target="dummyfram"
                  style={{ height: "auto" }}
                  onSubmit={e => {
                    message.success("Email is sent!", 5);
                  }}
                >
                  <h1>
                    {props.language === "en" ? "Contact us!" : "Kontakt os!"}
                  </h1>
                  <p>
                    <label>Email</label>
                    <input
                      class="form-control"
                      type="email"
                      name="email"
                      id="emailid"
                      required
                    />
                  </p>
                  <p>
                    <label> {props.language === "en" ? "Name" : "Navn"}</label>
                    <input
                      class="form-control"
                      type="text"
                      id="nameid"
                      name="name"
                      required
                    />
                  </p>
                  <p>
                    <label>
                      {props.language === "en" ? "Message" : "Besked"}
                    </label>
                    <textarea
                      style={{ resize: "both" }}
                      rows="4"
                      cols="50"
                      class="form-control"
                      type="text"
                      name="text"
                      id="textid"
                      required
                    />
                  </p>

                  <Button htmlType="submit">Send</Button>
                </form>
              </div>
            </div>
          </Col>
          <Col sm={24} md={{ span: 14 }}>
            <div className="block_align">
              <Col>
                <h3>Institute of Leadership Dynamics A/S</h3>
                <p>
                  <a
                    style={{ color: "#000" }}
                    href="mailto:info@leadershipdynamic.net"
                  >
                    info@leadershipdynamic.net
                  </a>
                </p>
                <p>+45 40 18 44 34</p>
                <Row>
                  <a
                    style={{ color: "#000" }}
                    href="https://www.facebook.com/Institute-of-Leadership-Dynamics-1131072530339933/"
                  >
                    <Icon style={{ padding: "10px" }} type="facebook" />
                  </a>

                  <a
                    style={{ color: "#000" }}
                    href="https://www.linkedin.com/company/institute-of-leadership-dynamics/about/"
                  >
                    <Icon style={{ padding: "10px" }} type="linkedin" />
                  </a>
                </Row>
              </Col>
              <div />
            </div>
          </Col>
        </Row>
      </Content>

      <FooterContainer />
    </Layout>
  );
}

function mapStateToProps(state) {
  return {
    language: state.preference.language
  };
}

export default connect(mapStateToProps)(Contact);



// WEBPACK FOOTER //
// ./src/pages/Contact/index.js